//Custom components
import { IOwnedProperty } from "../ClientInformation/types";
import { IInterestedProperty } from "../RealEstateGoals/types";
import ReviewCard from "./ReviewCard";

//Services
import { useApplicationFormContext } from "features/ApplicationForm/ApplicationFormProvider";

export default function Review() {
  const { setCurrentStep, data } = useApplicationFormContext();

  const { applicantInformation, step1, step2 } = data;

  return (
    <div className={`space-y-5 px-6 py-4 lg:col-span-9`}>
      <ReviewCard
        title="Applicant Information"
        handleEdit={() => setCurrentStep(0)}
      >
        <dl>
          <div className="bg-white px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
            <dt className="text-sm font-medium text-gray-500">Full Name</dt>
            <dd className="mt-1 text-sm text-gray-900 capitalize sm:mt-0 sm:col-span-2">
              {applicantInformation?.fullName}
            </dd>
          </div>
          <div className="bg-gray-50 px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
            <dt className="text-sm font-medium text-gray-500">E-mail</dt>
            <dd className="mt-1 text-sm text-gray-900 normal-case sm:mt-0 sm:col-span-2">
              {applicantInformation?.contactEmail}
            </dd>
          </div>
        </dl>
      </ReviewCard>
      <ReviewCard
        title="Client Information"
        handleEdit={() => setCurrentStep(1)}
      >
        <dl>
          <div className="bg-white px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
            <dt className="text-sm font-medium text-gray-500">Name</dt>
            <dd className="mt-1 text-sm text-gray-900 capitalize sm:mt-0 sm:col-span-2">
              {step1?.section1?.name}
            </dd>
          </div>
          <div className="bg-gray-50 px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
            <dt className="text-sm font-medium text-gray-500">Date of Birth</dt>
            <dd className="mt-1 text-sm text-gray-900 normal-case sm:mt-0 sm:col-span-2">
              {step1?.section1?.dob}
            </dd>
          </div>
          <div className="bg-white px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
            <dt className="text-sm font-medium text-gray-500">Race</dt>
            <dd className="mt-1 text-sm text-gray-900 normal-case sm:mt-0 sm:col-span-2">
              {step1?.section1?.race}
            </dd>
          </div>
          <div className="bg-gray-50 px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
            <dt className="text-sm font-medium text-gray-500">Phone</dt>
            <dd className="mt-1 text-sm text-gray-900 normal-case sm:mt-0 sm:col-span-2">
              {step1?.section1?.phone}
            </dd>
          </div>
          <div className="bg-white px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
            <dt className="text-sm font-medium text-gray-500">Email</dt>
            <dd className="mt-1 text-sm text-gray-900 normal-case sm:mt-0 sm:col-span-2">
              {step1?.section1?.email}
            </dd>
          </div>
          <div className="bg-gray-50 px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
            <dt className="text-sm font-medium text-gray-500">Client Type</dt>
            <dd className="mt-1 text-sm text-gray-900 capitalize sm:mt-0 sm:col-span-2">
              {step1?.section1?.clientType}
            </dd>
          </div>
          <div className="bg-white px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
            <dt className="text-sm font-medium text-gray-500">
              Street Address
            </dt>
            <dd className="mt-1 text-sm text-gray-900 normal-case sm:mt-0 sm:col-span-2">
              {step1?.section2?.streetAddress}
            </dd>
          </div>
          <div className="bg-gray-50 px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
            <dt className="text-sm font-medium text-gray-500">
              Do you own or rent ?
            </dt>
            <dd className="mt-1 text-sm text-gray-900 capitalize sm:mt-0 sm:col-span-2">
              {step1?.section2?.rentStatus}
            </dd>
          </div>
          <div className="bg-white px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
            <dt className="text-sm font-medium text-gray-500">City</dt>
            <dd className="mt-1 text-sm text-gray-900 capitalize sm:mt-0 sm:col-span-2">
              {step1?.section2?.city}
            </dd>
          </div>
          <div className="bg-gray-50 px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
            <dt className="text-sm font-medium text-gray-500">
              State / Province
            </dt>
            <dd className="mt-1 text-sm text-gray-900 normal-case sm:mt-0 sm:col-span-2">
              {step1?.section2?.state}
            </dd>
          </div>
          <div className="bg-white px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
            <dt className="text-sm font-medium text-gray-500">
              Zip / Postal Code
            </dt>
            <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
              {step1?.section2?.zipCode}
            </dd>
          </div>
          <div className="bg-gray-50 px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
            <dt className="text-sm font-medium text-gray-500">
              How long have you been on your current address ?
            </dt>
            <dd className="mt-1 text-sm text-gray-900 capitalize sm:mt-0 sm:col-span-2">
              {step1?.section2?.lengthInYears}
            </dd>
          </div>
          <div className="bg-white px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
            <dt className="text-sm font-medium text-gray-500">
              Are there any outstanding code violations or municipal liens on
              this property?
            </dt>
            <dd className="mt-1 text-sm text-gray-900 capitalize sm:mt-0 sm:col-span-2">
              {step1?.section2?.codeViolation}
            </dd>
          </div>
          <div className="bg-gray-50 px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
            <dt className="text-sm font-medium text-gray-500">
              Are you up to date on ?
            </dt>
            <dd className="mt-1 text-sm text-gray-900 capitalize sm:mt-0 sm:col-span-2">
              {`Property taxes : ${step1?.section3?.propertyTaxes}, Water Bills : ${step1?.section3?.waterBills}, Sewage Bills : ${step1?.section3?.sewageBills}, Refuse Bills : ${step1?.section3?.refuseBills}, `}
            </dd>
          </div>
        </dl>
      </ReviewCard>
      {step1?.section4?.ownedProperties?.length > 0 && (
        <ReviewCard
          title="List of properties you own"
          handleEdit={() => setCurrentStep(1)}
        >
          {step1?.section4?.ownedProperties?.map((address: IOwnedProperty) => (
            <div className="bg-white pt-5">
              <div className="border rounded p-5 bg-white">
                <h6 className="text-sm normal-case">{address.propertyName}</h6>
                <small className="text-gray-400">{`${address.streetAddress}, ${address.city}, ${address.state} ${address.zipCode}`}</small>
              </div>
            </div>
          ))}
        </ReviewCard>
      )}

      <ReviewCard
        title="Real Estate Goals"
        handleEdit={() => setCurrentStep(2)}
      >
        <dl>
          <div className="bg-white px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
            <dt className="text-sm font-medium text-gray-500">
              Have you identified a property ?
            </dt>
            <dd className="mt-1 text-sm text-gray-900 capitalize sm:mt-0 sm:col-span-2">
              {step2.q1}
            </dd>
          </div>
          {step2?.q1 === "no" && (
            <div className="bg-white px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
              <dt className="text-sm font-medium text-gray-500">
                Tell us more about the property
              </dt>
              <dd className="mt-1 text-sm text-gray-900 capitalize sm:mt-0 sm:col-span-2">
                {step2["q1-interestedPropertyDetail"]}
              </dd>
            </div>
          )}
          {step2?.q1 === "yes" && (
            <div className="bg-white p-6">
              <dt className="font-semibold text-gray-500">
                List of properties of interest
              </dt>
              {step2?.interestedProperties?.map(
                (address: IInterestedProperty) => (
                  <div className="bg-white pt-2">
                    <div className="border rounded p-5 bg-white">
                      <h6 className="text-sm normal-case">{`${address.streetAddress}, ${address.city}, ${address.state} ${address.zipCode}`}</h6>
                    </div>
                  </div>
                )
              )}
            </div>
          )}
          <div className="bg-gray-50 px-4 py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
            <dt className="text-sm font-medium text-gray-500">
              Are you interested in a property that directly borders land you
              already own?
            </dt>
            <dd className="mt-1 text-sm text-gray-900 capitalize sm:mt-0 sm:col-span-2">
              {step2.q2}
            </dd>
          </div>
        </dl>
      </ReviewCard>
    </div>
  );
}
